module.exports = __webpack_public_path__ + "static/media/imge-2.c41ab166.jpg";